@if (!loading && hasData) {
  <forge-card class="processes no-padding">
    @for (item of list; track item; let last = $last) {
      <div>
        <processing-card [enableLink]="enableLink" [entity]="item"></processing-card>
        <forge-divider [ngClass]="{'last-child': last}"></forge-divider>
      </div>
    }
  </forge-card>
}